import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

import Paragraph from '../Paragraph';

const ARROW_RIGHT = require('./arrow-right.svg');
const OVERLAY = require('./overlay.png');

export default class FeaturedArticleSlide extends Component {
  render() {
    const dynamicStyles = StyleSheet.create({
      hero_container: {
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundImage: this.props.featured_image_url ? 'url("' + this.props.featured_image_url + '")' : null,
      },
    });

    return (
      <div className={css(styles.container, dynamicStyles.hero_container)}>
        <img className={css(styles.image)} src={OVERLAY} />
        <div className={css(styles.half_row, styles.hidden_mobile)}></div>
        <div className={css(styles.half_row)}>
          <div className={css(styles.small_column)}></div>
          <div className={css(styles.large_column, styles.small_row)}>
            <div className={css(styles.category_title)}>Featured post</div>
            <Link to={{
              pathname: `/${this.props.content_type}/${this.props.slug}`,
              state: {
                post: this.props
              }
            }} className={css(styles.title)}>{this.props.title}</Link>
            <Paragraph style={styles.summary}>{this.props.summary}</Paragraph>
            <Link to={{
              pathname: `/${this.props.content_type}/${this.props.slug}`,
              state: {
                post: this.props
              }
            }} className={css(styles.read_more)}>
              <img src={ARROW_RIGHT} className={css(styles.arrow)} />
              Read more
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    position: 'relative',
    backgroundColor: Theme.black,
    width: Theme.featured_article_slider.width,
    height: Theme.featured_article_slider.height,
    [Theme.mobile_query]: {
      height: window.innerHeight - (Theme.navigation.height),
    }
  },
  hidden_mobile: {
    [Theme.mobile_query]: {
      display: 'none'
    },
  },
  half_row: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    [Theme.mobile_query]: {
      padding: 20,
      boxSizing: 'border-box',
    },
  },
  small_column: {
    flex: 3,
  },
  large_column: {
    position: 'relative',
    flex: 4,
    zIndex: 3,
  },
  small_row: {
    width: '75%',
  },
  image: {
    zIndex: 1,
    position: 'absolute',
    left: 0,
    top: 0,
    width: Theme.featured_article_slider.width,
    height: Theme.featured_article_slider.height,
    [Theme.mobile_query]: {
      height: window.innerHeight - (Theme.navigation.height),
    }
  },
  category_title: {
    position: 'relative',
    display: 'inline-block',
    fontSize: 11,
    letterSpacing: 1,
    fontFamily: Theme.fontFamily,
    color: Theme.primary,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: 25,
    ':after': {
      position: 'absolute',
      display: 'block',
      bottom: -8,
      left: 0,
      content: "' '",
      width: '100%',
      height: 2,
      backgroundColor: Theme.primary,
      transition: "all 120ms ease-in-out",
    },
    ":hover": {
      ':after': {
        position: 'absolute',
        opacity: 0,
        display: 'block',
        bottom: -3,
        left: 0,
        content: "' '",
        width: '100%',
        height: 2,
        backgroundColor: Theme.primary,
      },
    },
  },
  title: {
    display: 'block',
    fontFamily: Theme.fontFamily,
    fontSize: 40,
    fontWeight: 'bold',
    color: Theme.white,
    marginTop: 15,
    marginBottom: 15,
    lineHeight: '50px',
    transition: "all 120ms ease-in-out",
    ':hover': {
      color: Theme.primary
    },
  },
  summary: {
    color: Theme.white,
    lineHeight: '22px',
    marginBottom: 15,
  },
  read_more: {
    position: 'relative',
    display: 'inline-block',
    fontFamily: Theme.fontFamily,
    fontWeight: 700,
    fontSize: 14,
    color: Theme.white,
    textTransform: 'uppercase',
    transition: "all 120ms ease-in-out",
    letterSpacing: 1,
    ':after': {
      position: 'absolute',
      opacity: 0,
      display: 'block',
      bottom: -3,
      left: 0,
      content: "' '",
      width: '100%',
      height: 2,
      backgroundColor: Theme.white,
      transition: "all 120ms ease-in-out",
    },
    ":hover": {
      opacity: '0.5'
    }
  },
  arrow: {
    display: 'inline',
    marginRight: 10,
  }
})



// WEBPACK FOOTER //
// ./src/components/FeaturedArticleSlide/index.js